export default __webpack_public_path__ + "static/media/Download.0f8c0f11.svg";